import React from 'react';
import classnames from "classnames/bind";
import moment from "moment";
import { DatePicker, Icon, Pagination, Table } from "neatui";
import Styles from './index.scss';
import ajax from "../../../util/ajax";

const cx = classnames.bind(Styles);

const datePickerConfig = {
  type: 'date',
  placeholder: '月份选择',
  format: 'YYYY-MM',
  selectType: 'select-month',
  readOnly: true,
  showTime: true,
  disabled: false,
};
const MCN_INCOME_LIST = '/mcn/punish/list.do';

class ContentViolation extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tableData: {
        list: [],
        total: 0,
      },
      countData: {
        total: 0,
        thisMonth: 0,
      },
      searchData: {
        month: moment().format('YYYY-MM'),
        pageNo: 1,
        size: 20,
      },
    }
  }

  componentDidMount() {
    this.fetchCounter();
    this.fetchData();
  }

  fetchCounter = () => {
    ajax(
      '/mcn/punish/count.do',
      {
        method: 'get',
      },
      res => {
        const { data } = res;
        this.setState({
          countData: data,
        })
      },
    ).then(() => {

    });
  };

  fetchData = () => {
    const { searchData } = this.state;
    const { month, pageNo, size } = searchData;
    ajax(
      MCN_INCOME_LIST,
      {
        method: 'get',
        params: {
          month,
          pageNo,
          size,
        },
      },
      res => {
        const { data } = res;
        this.setState({
          tableData: data,
        });
      },
    ).then(() => {

    });
  };

  handleDateChange = time => {
    const { searchData } = this.state;
    searchData.month = time;
    searchData.pageNo = 1;
    this.setState({
      searchData: { ...searchData }
    }, () => {
      // this.fetchData();
    });
  };

  handlePageChange = page => {
    const { searchData } = this.state;
    searchData.pageNo = page;
    this.setState({
      searchData: { ...searchData }
    }, () => {
      // this.fetchData();
    });
  };

  initTableData = () => {
    const { tableData } = this.state;
    const { list } = tableData;

    const tableConfig = {
      columns: [
        { title: '帐号名称', key: 'childTName' },
        { title: '内容标题', key: 'title', style: { width: '400px' } },
        { title: '时间', key: 'createTime' },
      ],
      dataSource: list,
      longTable: false,
      checkBox: false,
      allBorder: false,
      stripe: true,
      isHover: true,
      textCenter: true,
    };
    return tableConfig;
  };

  disabledDate = date => {
    const time = date.valueOf();
    const now = Date.now();
    const onlineTime = new Date(2022, 7, 1, 0, 0, 0).getTime();

    return time <= onlineTime || time  > now;
  };

  render() {
    const { tableData, searchData, countData } = this.state;
    const { total } = tableData;
    const { size, pageNo, month } = searchData;

    return (
      <div className={cx('content-violation')}>
        <div className={cx('content-violation__title')}>
          内容违规
        </div>
        <div className={cx('content-violation__box')}>
          <div className={cx('content-violation__box__total')}>
            <p>违规总条数</p>
            <span>{countData.total}</span>
          </div>
          <div className={cx('content-violation__box__current')}>
            <p>本月违规次数</p>
            <span>{countData.thisMonth}</span>
          </div>
        </div>
        <div className={cx('content-violation__form')}>
          <div className={cx('content-violation__form__picker')}>
            <DatePicker
              inputPrefix={<Icon type="date" />}
              {...datePickerConfig}
              defaultValue={month}
              disabledDate={this.disabledDate}
              onChange={this.handleDateChange}/>
          </div>
        </div>

        <Table {...this.initTableData()} className="mcn-table" />

        <div className="pagination">
          <Pagination
            showQuickJump
            onChange={this.handlePageChange}
            total={total}
            pageSize={size}
            current={pageNo}/>
        </div>
      </div>
    );
  }
}

export default ContentViolation;
